import { Skeleton, Table } from '@/components';
import type { FC } from 'react';

export const ProjectsTableSkeleton: FC = () => {
  const columnsNum = 5;
  const rowsNum = 5;

  const columns = [...Array(columnsNum)].map((_, i) => ({
    dataIndex: `col${i}`,
  }));

  const dataSource = [...Array(rowsNum)].map((_, i) => {
    const data = { key: `${i}` };
    for (const { dataIndex } of columns) {
      data[dataIndex] = <Skeleton.Input active size="small" />;
    }

    return data;
  });

  return (
    <Table
      showHeader={false}
      pagination={false}
      rowHoverable={false}
      dataSource={dataSource}
      columns={columns}
      style={{ width: '100%', marginBottom: 40 }}
    />
  );
};
